// extracted by mini-css-extract-plugin
export default {"main":"MenuItem_main__+8B74","icon":"MenuItem_icon__TLzC0","name":"MenuItem_name__ZYzvK"};